import request from "../utils/request";

export function getMentions(pagination) {
  return request({
    url: `/mentions`,
    method: "get",
    params: pagination,
  });
}

export function getRecordMentions(recordType, recordId) {
  return request({
    url: `/mentions/${recordType}/${recordId}`,
    method: "get",
  });
}

export function updateMention(mention, delta) {
  return request({
    url: `/mentions/${mention._id}/`,
    method: "patch",
    data: delta,
  });
}
